import Notifications from '../notifications/Notifications.vue';
import Carousel from '../../../sharedComponents/carousel/Carousel.vue';
import WidgetNews from '../../../components/widget-news/WidgetNews.vue';
import WidgetBonuses from '../../../components/widget-bonuses/WidgetBonuses.vue';
import WidgetProfile from '../../../components/widget-profile/WidgetProfile.vue';
import WidgetPurse from '../../../components/widget-purse/WidgetPurse.vue';
import WidgetSales from '../../../components/widget-sales/WidgetSales.vue';
import WidgetAccount from '../../../components/widget-account/WidgetAccount.vue';
import WidgetRating from '../../../components/widget-rating/WidgetRating.vue';
import WidgetLimits from '../../../components/widget-limits/WidgetLimits.vue';
import WidgetRules from '../../../components/widget-rules/WidgetRules.vue';
import WidgetActions from '../../../components/widget-actions/WidgetActions.vue';
import WidgetTasks from '../../../components/widget-tasks/WidgetTasks.vue';


export default {
  data() {
    return {
      pagePers: null,
      dialogPers: false,
    };
  },
  components: {
    Notifications,
    Carousel,
    WidgetNews,
    WidgetBonuses,
    WidgetProfile,
    WidgetPurse,
    WidgetSales,
    WidgetAccount,
    WidgetRating,
    WidgetLimits,
    WidgetRules,
    WidgetActions,
    WidgetTasks,

  },
  computed: {
    requirePers() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_pers === true
          && state.user
          && !state.user.pers_at
      );
    },
    user() { return this.$store.state.user; },
    account() { return this.$store.state.user.account; },
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
    isBlocked() { return !!(this.$store.getters.isBlocked); },
    onModeration() { return !!(this.$store.getters.onModeration); },
    isApproved() { return !!(this.$store.getters.isApproved); },
    hasNotifications() { return this.$store.state.notifications.hasNotifications; },
    isBannersOn() { return this.$store.state.settings.module_banners === true; },
    banners() { return this.$store.state.banners.bannersList || []; },
    taxes() { return this.$store.state.settings.taxes === true; },
    loading() { return this.$store.state.loading; },
    news() { return this.$store.state.news.news || []; },
    rating() { return this.$store.state.rating.rating || []; },
    period() { return this.$store.state.rating.period || null; },
    limits() { return this.$store.state.limits.limits || []; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { /* + */ return this.$store.getters.isDealer; },
    isRus() { return this.$store.getters.isRus; },
    isBy() { return this.$store.getters.isBy; },
    isKz() { return this.$store.getters.isKz; },
    surveys() { return this.$store.state.surveys.surveys; },
    showLimits() {
      return this.isApproved && this.isDealer && this.limits
        && this.limits.length && this.user.show_limits;
    },
    actualGamesCount() { return this.$store.state.game.actualGamesCount || 0; },
    gamesList() { return this.$store.state.game.gamesList || []; },
  },
  methods: {
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/auth/confirm-pers', { profile_id: app.user.profile_id })
        .then(() => {
          app.user.pers_at = true;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info')
        .then((response) => {
          app.pagePers = response.data.pagePers;
        });
    },
    getUserData(id) {
      this.$store.dispatch('notifications/GetNotifications', id);
      this.$store.dispatch('rating/GetRating', id);
      this.$store.dispatch('news/GetNews', { profile_id: id, limit: 4 });
    },
  },
  watch: {
    surveys(val) {
      val && val.length && this.$router.push('/surveys');
    },
  },
  async created() {
    await this.$store.dispatch('GetSettings');
    await this.$store.dispatch('GetProfile')
      .then(({ profile }) => {
        this.getUserData(profile.profile_id);
        profile.show_limits && this.$store.dispatch('limits/GetLimits', profile.profile_id);
        this.$store.dispatch('game/GetGamesList', { profile_id: profile.profile_id });
      });
  },
  async mounted() {
    this.isBannersOn && await this.$store.dispatch('banners/GetBannersList');
    if (this.requirePers) {
      this.LoadPers();
    }
  },
};
